import React from "react";

import Icon from "components/Icon";

import {
  Wrapper,
  Inner,
  Title,
  Description,
  Image,
  Meta,
  Details
} from "./styles";

const Event = ({ content }) => {
  return (
    <Wrapper
      href={content.path}
      as={!content.path && "div"}
      target="_blank"
      rel="noopener noreferrer"
    >
      {content.image && <Image content={content.image} height="160px" />}
      <Inner>
        <Title>{content.title}</Title>
        {content.description && (
          <Description>{content.description}</Description>
        )}
        <Details>
          {content.date && (
            <Meta>
              <Icon icon="clock" m="4px 5px 0 0" />
              {content.date}
            </Meta>
          )}
          {content.location && (
            <Meta>
              <Icon icon="location" m="4px 5px 0 0" />
              {content.location}
            </Meta>
          )}
        </Details>
      </Inner>
    </Wrapper>
  );
};

export default Event;
